import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueAgronomo, IDataAgronomo } from "../../types/api/geral/pesquisar-agronomo";

export default function SelectAgronomo({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    onChange,
    disabled = false
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error, disabled }}
                label={`Agrônomo`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setOpenModal(true);
                    }
                  }}
                slotProps={{
                    input: {readOnly: true}
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar agrônomo"
                        queryPath="/receituario-agronomico/pesquisar-agronomo"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        defaultValue={value || defValueAgronomo}
                        onChange={(value) => {
                            onChange(value as IDataAgronomo)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataAgronomo | null | undefined
    onChange: (arg: IDataAgronomo | null) => void
    required?: boolean
    error?: boolean
    errorMessage?: string | undefined
    disabled?: boolean
}